import { NitroLoading, NitroModal, NitroParagraph } from 'nitro-components';
import styled from 'styled-components';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import getAuth0 from '../../utils/auth0/client';
import * as loginActions from '../../auth/actions';

const ModalContent = styled.div`
  width: 100%;
`;

const NoCancel = styled.div`
  & button:first-child {
    display: none;
  }
`;

class Auth0Redirect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: ''
    };
  }

  componentWillMount() {
    this.checkSession();
  }

  async checkSession() {
    try {
      const auth0 = await getAuth0();

      const query = window.location.search;
      if (
        (query.includes('code=') || query.includes('error=')) &&
        query.includes('state=')
      ) {
        await auth0.handleRedirectCallback();

        window.location.href = '/';
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('err', err);
      this.setState({ error: err.message });
    }
  }

  render() {
    const { error } = this.state;

    if (error) {
      return (
        <NoCancel>
          <NitroModal
            title="Login failed"
            action={() => {
              window.location.href = '/';
            }}
            actionLabel="Try Again"
            extraAction={false}
            isOpen
            close={() => {
              window.location.href = '/';
            }}
            messageFlexDirection="row"
          >
            <ModalContent>
              <NitroParagraph align="center">
                An error was encountered while logging in: {error}
              </NitroParagraph>
            </ModalContent>
          </NitroModal>
        </NoCancel>
      );
    }

    return <NitroLoading center />;
  }
}

Auth0Redirect.propTypes = {
  actions: PropTypes.object.isRequired,
  auth: PropTypes.object
};

Auth0Redirect.contextTypes = {
  router: PropTypes.object
};

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(loginActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth0Redirect);



// WEBPACK FOOTER //
// ./src/features/auth-0-redirect/index.js